export default __webpack_public_path__ + "static/media/Photosnap - Hero.86d5f958.png";